<template>
  <div
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
    
  >
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div class="sidenav-header d-flex align-items-center">
        <a class="navbar-brand" href="/#/projects">
          <!-- <img :src="logo" class="navbar-brand-img" alt="Sidebar logo" /> -->
          <!-- <h4>{{appTitle}}</h4> -->
          <img src="@/assets/imanandai_logo_light.svg" width="150" height="50" class="m-0" style="max-height:initial;">
        </a>
        <div class="ml-auto">
          <!-- Sidenav toggler -->
          <!--  -->
          <el-button size="medium" class="mr-3" style="border:0;" circle @click.prevent="minimizeSidebar">
            <i class="fas" :class="[!$sidebar.isMinimized ? 'fa-caret-left' : 'fa-caret-right']" style="background-color:white;border:0;"></i>
          </el-button>

          <div
            v-if="false"
            class="sidenav-toggler "
            :class="{ active: !$sidebar.isMinimized }"
            @click="minimizeSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
      <div class="navbar-inner">
        <ul class="navbar-nav">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </ul>
        <slot name="links-after"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  data () {
    return {
    }
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE
    }
  },
  props: {
    title: {
      type: String,
      default: "Creative Tim",
      description: "Sidebar title",
    },
    shortTitle: {
      type: String,
      default: "CT",
      description: "Sidebar short title",
    },
    logo: {
      type: String,
      default:
        "https://demos.creative-tim.com/vue-argon-dashboard-pro/img/brand/green.png",
      description: "Sidebar app logo",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these.",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  mounted() {
    // this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
    //this.$sidebar.isMinimized = true
    this.minimizeSidebar();
  },
  beforeUnmount() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
